/** @copyright (c) Viewpost. All Rights Reserved. See LICENSE for more details. */

import { dateMapper } from 'api/common/mappers/coreMappers';
import { PaymentTrackerStepType } from 'schemas/payments/tracker';
import { getPaymentMethodEnum } from 'utils/paymentUtils';

export function mapPaymentTracker(apiTracker, apiPaymentMethod, isIclOptimized = false, masterInvoiceId) {
  if (!apiTracker || apiTracker.length === 0) {
    return null;
  }
  let steps = apiTracker.map((apiStep) => {
    let stepType = PaymentTrackerStepType.meta.map.Unknown;
    if (Object.keys(PaymentTrackerStepType.meta.map).includes(apiStep.step)) {
      stepType = PaymentTrackerStepType.meta.map[apiStep.step];
    }
    return {
      date: dateMapper(apiStep.date),
      deliverByDate: dateMapper(apiStep.deliveryDate),
      stepType,
      isVoid: apiStep.isVoid,
      isRefund: apiStep.isRefund,
      firstName: apiStep.firstName,
      lastName: apiStep.lastName,
      reason: apiStep.reason,
      amount: apiStep.amount,
      referenceNumber: apiStep.referenceNumber,
      paymentMethodType: apiStep.paymentMethodType === 'Unknown'
        ? null
        : getPaymentMethodEnum(apiStep.paymentMethodType),
      toAccountSuffix: apiStep.toAccountSuffix,
      toCompanyName: apiStep.toCompanyName,

      splitAmount: apiStep.splitAmount,
      splitReferenceNumber: apiStep.splitReferenceNumber,
      splitPaymentMethodType: getPaymentMethodEnum(apiStep.splitPaymentMethodType)
    };
  });
  return {
    steps,
    paymentMethodType: getPaymentMethodEnum(apiPaymentMethod, isIclOptimized),
    masterInvoiceId
  };
}

export function mapSettlementRole(apiSettlementRole) {
  if (typeof apiSettlementRole === 'string') return apiSettlementRole;
  switch (apiSettlementRole) {
    case 1:
      return 'VccPayment';
    case 2:
      return 'VccPaymentReroute';
    case 3:
      return 'VccPaymentPartialReroute';
    case 4:
      return 'VccPaymentPrefund';
    case 5:
      return 'VccPaymentOverLimitSplit';
    case 6:
      return 'VccPaymentRefund';
    case 7:
      return 'VccPaymentPartialRefund';
    case 8:
      return 'VccPaymentReimbursement';
    default:
      return 'None';
  }
}
